export const namespaces = {
    common: "common",
};

export const languages = {
    it: "it",
    en: "en",
    de: "de",
};